﻿import carouselExtItemCtrl from './carouselExtItem.ctrl.js';

export const carouselExtItemComponent = {
    require: {
        carouselExtRoot: '^^carouselExtRoot',
    },
    controller: carouselExtItemCtrl,
    bindings: {},
};
